import React from "react";
import styles from "./document.module.css";
import backgroundImage from "./../../assets/16.09.2022-2-1-2.jpg";

export const Docs = () => {
  const documentList = [
    {
      name: "წესდება",
      filename: "wesdeba.pdf",
    },
    {
      name: "ა(ა)იპ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის სამსახურეობრივი ინსტრუქციები",
      filename: "samsaxuris_instruqciebi.pdf",
    },
    {
      name: "სამედიცინო პერსონალის საქმიანობის და სკოლაში სამედიცინო მომსახურების სივრცის ფუნქციონირების დებულება",
      filename: "sameditico.pdf",
    },
    {
      name: "პედაგოგთა საბჭოს დებულება",
      filename: "pedagogta_sabchos_debuleba.pdf",
    },
    {
      name: "ბიბლიოთეკის დებულება",
      filename: "bibliotekis_debuleba.pdf",
    },
    {
      name: "საგანგებო მართვის გეგმა",
      filename: "sagangebo_situaciebisas_reagirebis_martva.pdf",
    },
    {
      name: "დისციპლინური კომიტეტის დებულება",
      filename: "disciplinuri_sabchos_debuleba.pdf",
    },
    {
      name: "მშობელთა სათათბიროს დებულება",
      filename: "mshoblis_satatbiro_debuleba.pdf",
    },
    {
      name: "უსაფრთხოებისა და საზოგადოებრივი წესრიგის დაცვის წესი და პირობები",
      filename:
        "usafrtxoebis_da_sazogadoebrivi_westigis_dacvis_wesi_da_pirobebi.pdf",
    },
    {
      name: "უსაფრთხოებისა და საზოგადოებრივ წესრიგის დაცვაზე პასუხისმგებელი პირის განსაზღვრის შესახებ",
      filename: "usafrtxoeba.pdf",
    },
    {
      name: "პერსონალურ მონაცემთა დაცვის მექანიზმი",
      filename: "personalur_monacemta_dacvis_meqanizmi.pdf",
    },
    {
      name: "27.12.2019 ავტორიზაციის საბჭოს გადაწყვეტილება",
      filename: "avtorizaciis_sabchos_gadawkvetileba_27.12.2019.pdf",
    },
    {
      name: "შეფასების ვერიფიკაციის მექანიზმი",
      filename: "verifikacia.pdf",
    },
    {
      name: "სტრატეგიული განვითარების, სამოქმედო და სასკოლო-სასწავლო გეგმების შემუშავების, მონიტორინგის და შეფასების მეთოდოლოგია",
      filename:
        "strategiuli_ganvitarebis_samoqmedo_da_saskolo_saswavlo_gegmebis_shemushaveba.pdf",
    },
    {
      name: "შრომის უსაფრთხოების გეგმა",
      filename: "shromis_usafrtxoeba.pdf",
    },
    {
      name: "მოსწავლის, პერსონალის, მშობლის/კანონიერი წარმომადგენლის უფლებების დაცვის პოლიტიკა",
      filename: "uflebispolitika.pdf",
    },
    {
      name: "რემედიაციის პროგრამა",
      filename: "remediacia.pdf",
    },

    {
      name: "პერსონალის მართვის პოლიტიკა და თანამშრომლის სამუშაო გარემოსთან ინტეგრაცია",
      filename: "integracia.pdf",
    },
    {
      name: "კურიკულუმის შემუშავებისა და გადასინჯვა-რეზერვის მოთოდოლოგიის დოკუმენტი",
      filename: "kurikulumi.pdf",
    },

    {
      name: "სკოლის თანამშრომელთა საკვალიფიკაციო მოთხოვნები",
      filename: "tanamshromeli.pdf",
    },
    {
      name: "მასწავლებლის ეთიკის კოდექსი",
      filename: "moswavlis_etikis_kodeqsi.pdf",
    },
    {
      name: "საქმისწარმოების წესი",
      filename: "saqmiswarmoebis_wesi.pdf",
    },
    {
      name: "ბავშვის მიმართ განხორციელებული ძალადობასთან დაკავშირებული შიდა ინსტრუქციების დამტკიცებისა და უფლებამოსილების პირის განსაზღვრის შესახებ",
      filename: "dzaladoba.pdf",
    },
    {
      name: "მოსწავლის ჩარიცხვის, საფეხურის დაძლევის, მობილობის, სტატუსის შეჩერების/აღდგენის და შეწყვეტის წესი",
      filename: "charicxva.pdf",
    },
    {
      name: " სკოლის ძირითადი და დამხმარე პროცესების დოკუმენტი",
      filename: "damkhmare.pdf",
    },
    {
      name: "განცხადებისა და საჩივრის განხილვის წესი",
      filename: "sachivari.pdf",
    },
    {
      name: "მოსწავლეთა ადაპტაციის წესი",
      filename: "adaptacia.pdf",
    },
    {
      name: "საცხობის მონიტორინგის დასკვნა",
      filename: "sacxobi.pdf",
    },
  ];

  const backgroundStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
  };

  return (
    <div style={backgroundStyle}>
      <div className={styles.documentsPage}>
        <header className={styles.header}>
          <h1>დოკუმენტები</h1>
        </header>
        <div className={styles.documentsContainer}>
          {documentList.map((doc, index) => (
            <a
              key={index}
              className={styles.documentBox}
              target="_blank"
              rel="noreferrer noopener"
              href={`https://batumi-gimnazia.edu.ge/documents/${doc.filename}`}
            >
              {doc.name}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};
